import type { NativeMessages } from "../lib/enums/nativeMessages";

export const sendNativeMessage = ({
  message,
  properties,
}: {
  message: NativeMessages;
  properties?: any;
}) => {
  if (typeof window !== "undefined") {
    if ("webkit" in window)
      window.webkit.messageHandlers?.[message]?.postMessage(properties);
    else if ("Android" in window)
      // @ts-ignore
      window.Android?.[message]?.(JSON.stringify(properties));
  }
};
